// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3N-8Y","title":"Header_title__3Fw9G","left":"Header_left__2pZ-i","clinicName":"Header_clinicName__8yJRg"};